import React from 'react';
import PropTypes from 'prop-types';
import './TimecardsTable.css';

const TableHeader = ({
  columns,
  ...props
}) => {
  return (
    <thead>
      <tr className='timecards-header-row timecards-table-row'>
        { columns.map((header, index) => <th key={header} className='timecards-header-text'>{header}</th>) }
      </tr>
    </thead>
  );
};

TableHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string)
};

export default TableHeader;
